import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 우울 극복 방법 조회
function getOvercomeFromMomthera({pid}) {
    return AxiosInterceptor({
        url: '/overcome',
        method: 'get',
        params: {pid}
    })
}

export default getOvercomeFromMomthera;